"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactPose = _interopRequireDefault(require("react-pose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const Content = (0, _styledComponents.default)(_reactPose.default.div({
  show: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 350,
      delay: 200
    }
  },
  hide: {
    y: -20,
    opacity: 0,
    transition: {
      duration: 350
    }
  }
})).withConfig({
  displayName: "ContentBackdrop__Content",
  componentId: "rjfrzv-0"
})(["position:absolute;z-index:2;background:#fff;display:flex;justify-content:center;align-items:center;"]);
const Backdrop = (0, _styledComponents.default)(_reactPose.default.div({
  show: {
    height: 'auto',
    opacity: 1,
    transition: {
      duration: 350,
      height: {
        duration: 0
      }
    }
  },
  hide: {
    height: 0,
    opacity: 0,
    transition: {
      delay: 200,
      height: {
        delay: 550
      }
    }
  }
})).withConfig({
  displayName: "ContentBackdrop__Backdrop",
  componentId: "rjfrzv-1"
})(["position:fixed;top:0;right:0;bottom:0;left:0;background:rgba(0,0,0,0.2);z-index:1;"]);

class ContentBackdrop extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      show: false
    });

    _defineProperty(this, "handleClose", () => {
      const {
        onClose
      } = this.props;
      const {
        show
      } = this.state;

      if (!show) {
        onClose();
      }
    });

    _defineProperty(this, "handleHideBackdrop", () => {
      const {
        show
      } = this.state;

      if (!show) {
        return;
      }

      this.setState(() => ({
        show: false
      }));
    });
  }

  componentDidMount() {
    const {
      show
    } = this.props;
    this.setState(() => ({
      show
    }));
  }

  render() {
    const {
      className,
      children
    } = this.props;
    const {
      show
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: className
    }, /*#__PURE__*/_react.default.createElement(Content, {
      key: "content",
      pose: show ? 'show' : 'hide',
      onPoseComplete: this.handleClose
    }, children), ",", /*#__PURE__*/_react.default.createElement(Backdrop, {
      key: "backdrop",
      pose: show ? 'show' : 'hide',
      onClick: this.handleHideBackdrop
    }));
  }

}

var _default = (0, _styledComponents.default)(ContentBackdrop).withConfig({
  displayName: "ContentBackdrop",
  componentId: "rjfrzv-2"
})([""]);

exports.default = _default;